import axios from "axios";
import { APLICACION_COD, X_API_KEY, SERVICE_URL } from "consts/env";
import { fallbackURL } from "consts/FallbackURL";
import { emit } from "utils/eventManager";
import { clearAuth } from "../checkAuth";

// La pagina puede tener varias requests en vuelo (Promise.all, Get encadenados).
// Cuando una detecta la sesion vencida, las que llegan despues NO deben pisar el
// mensaje ni volver a navegar: ya estamos yendo a login.
let sesionExpirada = false;

// Tiempo que se le deja al snackbar para que se lea antes de recargar. El Snackbar
// se auto-cierra a los 2500ms, asi que entra completo.
const MS_ANTES_DE_REDIRIGIR = 2000;
const MSG_SESION = "Su sesion expiro por falta de actividad";

export default async function axiosPost(
    body,
    credentials = false
) {
    const headers = {
        "Content-Type": "application/json",
    };

    if (credentials) {
        headers["x-hooli-token"] = credentials.hooliToken || credentials.token;
        headers["x-session-id"] = credentials.sessionId;
    }

    headers["x-api-key"] = X_API_KEY;
    headers["x-origin-id"] = APLICACION_COD;

    try {
        const { data: result } = await axios.post(SERVICE_URL, body, { headers });
        if (!result || result === null || result === undefined) {
            return {
                status: {
                    code: 0,
                    errcode: 99999,
                    errmsg: "Error inesperado en request",
                    action: "U",
                    id: null,
                },
                result: [],
            };
        }

        if (result?.status?.code !== 1 && result?.status?.errcode === 10000) {
            clearAuth();
            sessionStorage.clear();
            // Antes se navegaba en el mismo tick: el snackbar apenas parpadeaba y el
            // navegador cancelaba hasta la request del icono.
            setTimeout(() => window.location.assign(fallbackURL), MS_ANTES_DE_REDIRIGIR);
            // Se devuelve un sobre bien formado y NO undefined: los servicios que todavia
            // hacen `return result.result` reventarian con "Cannot read properties of
            // undefined", y el overlay de error taparia el aviso de sesion vencida.
            // Con esto el patron viejo devuelve [status] y respuestaDe devuelve ok:false.
            return {
                status: {
                    code: 0,
                    errcode: 10000,
                    errmsg: result.status.errmsg || MSG_SESION,
                    action: "U",
                    id: null,
                },
                result: [],
            };
        }

        return result;
    } catch (err) {
        return {
            status: {
                code: 0,
                errcode: err.response ? err.response.status : 0,
                errmsg: err.message,
                action: "U",
                id: null,
            },
            result: [],
        };
    }
}
axios.interceptors.response.use(
    (response) => {
        // console.log(
        //     "Estos son los interceptors",
        //     response,
        //     window.sessionStorage.getItem("hooliToken")
        // );

        // if (
        //     response.data?.status?.errmsg ===
        //     "Su sesión ha expirado por falta de actividad"
        // ) {

        //     emit("sessionStorageChanged", {
        //         hooliToken: 0,
        //         sessionId: 0,
        //     });
        // }

        const status = response.data?.status;
        if (status && status.code !== 1) {
            if (status.errcode === 10000) {
                // Sesión expirada → limpiar y avisar (App.jsx redirige a login).
                if (sesionExpirada) return response;
                sesionExpirada = true;
                clearAuth();
                emit("sessionExpired", {
                    route: "/login",
                    message: status.errmsg || MSG_SESION,
                });
            } else if (sesionExpirada) {
                // Error derivado de una sesión que ya venció: se ignora para no tapar
                // el aviso que el usuario tiene que leer.
                return response;
            } else if (status.action === "E") {
                // El back marca action "E" cuando lo trata como error, y justamente ahi
                // es donde mas importa saber QUE paso: antes se descartaba el errmsg y se
                // mostraba siempre "Error de servidor". El fallback queda por si el back
                // no manda mensaje.
                emit("serverError", {
                    route: "/login",
                    message: status.errmsg || "Error de servidor",
                });
            } else {
                emit("serverError", { message: status.errmsg || "Error de servidor" });
            }
        }

        // IMPORTANTE: devolver SIEMPRE la response. Antes se hacía `return emit(...)`
        // (undefined) y axiosPost rompía con "Cannot destructure property 'data'".
        return response;
    },
    (error) => Promise.reject(error)
);